/**
 * ERZEUGT von tools/extension-registry/generate.cjs (WI#4521 AC-2) -- NICHT VON HAND AENDERN.
 *
 * Die gebuendelte Fassung der Ableitung: eingebettete Werte statt fs.readFileSync, weil es
 * im Browser kein node:fs gibt und `func publish` nur den api/-Baum packt. Quellen sind
 * dieselben wie bei extensions.generated.json -- die Manifeste unter extensions/ und deren
 * src/i18n/.
 *
 * Der Husky-Hook erneuert die Datei bei jedem Commit; ein Pipeline-Schritt rechnet gegen,
 * falls der Hook umgangen wurde.
 */
export const EXTENSION_COUNT = 5;
export const GENERATED_EXTENSIONS = [
    {
        id: 'p1-ado-filter',
        publisher: 'cool-tools',
        displayName: 'cool·tools ADO Advanced Filter',
        marketplaceSlug: 'cool-tools.p1-ado-filter',
        contributions: [
            {
                id: 'filter-hub',
                type: 'ms.vss-web.hub',
                targets: ['ms.vss-work-web.work-hub-group'],
            },
            {
                id: 'settings-page',
                type: 'ms.vss-web.hub',
                targets: ['ms.vss-web.project-admin-hub-group'],
            },
        ],
        locales: ['cs', 'de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'pl', 'pt-BR', 'ru', 'tr', 'zh-Hans', 'zh-Hant'],
        localeCount: 14,
    },
    {
        id: 'p2-work-item-freeze',
        publisher: 'cool-tools',
        displayName: 'cool·tools Work Item Freeze',
        marketplaceSlug: 'cool-tools.p2-work-item-freeze',
        contributions: [
            {
                id: 'freeze-banner',
                type: 'ms.vss-work-web.work-item-form-group',
                targets: ['ms.vss-work-web.work-item-form'],
            },
            {
                id: 'freeze-observer',
                type: 'ms.vss-work-web.work-item-notifications',
                targets: ['ms.vss-work-web.work-item-form'],
            },
            {
                id: 'board-watcher',
                type: 'ms.vss-web.action-provider',
                targets: ['ms.vss-work-web.backlog-board-pivot-filter-menu'],
            },
            {
                id: 'sprint-board-watcher',
                type: 'ms.vss-web.action-provider',
                targets: ['ms.vss-work-web.sprint-board-pivot-filter-menu'],
            },
            {
                id: 'settings-page',
                type: 'ms.vss-web.hub',
                targets: ['ms.vss-web.project-admin-hub-group'],
            },
        ],
        locales: ['cs', 'de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'pl', 'pt-BR', 'ru', 'tr', 'zh-Hans', 'zh-Hant'],
        localeCount: 14,
    },
    {
        id: 'p3-status-freeze',
        publisher: 'cool-tools',
        displayName: 'cool·tools Status Freeze',
        marketplaceSlug: 'cool-tools.p3-status-freeze',
        contributions: [
            {
                id: 'freeze-banner',
                type: 'ms.vss-work-web.work-item-form-group',
                targets: ['ms.vss-work-web.work-item-form'],
            },
            {
                id: 'freeze-observer',
                type: 'ms.vss-work-web.work-item-notifications',
                targets: ['ms.vss-work-web.work-item-form'],
            },
            {
                id: 'board-watcher',
                type: 'ms.vss-web.action-provider',
                targets: ['ms.vss-work-web.backlog-board-pivot-filter-menu'],
            },
            {
                id: 'sprint-board-watcher',
                type: 'ms.vss-web.action-provider',
                targets: ['ms.vss-work-web.sprint-board-pivot-filter-menu'],
            },
            {
                id: 'board-card-menu',
                type: 'ms.vss-web.action',
                targets: ['ms.vss-work-web.backlog-board-card-item-menu'],
            },
            {
                id: 'card-dialog',
                type: 'ms.vss-web.external-content',
                targets: [],
            },
            {
                id: 'settings-page',
                type: 'ms.vss-web.hub',
                targets: ['ms.vss-web.project-admin-hub-group'],
            },
        ],
        locales: ['cs', 'de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'pl', 'pt-BR', 'ru', 'tr', 'zh-Hans', 'zh-Hant'],
        localeCount: 14,
    },
    {
        id: 'p4-iteration-checker',
        publisher: 'cool-tools',
        displayName: 'cool·tools Iteration Checker',
        marketplaceSlug: 'cool-tools.p4-iteration-checker',
        contributions: [
            {
                id: 'hub',
                type: 'ms.vss-web.hub',
                targets: ['ms.vss-work-web.work-hub-group'],
            },
            {
                id: 'widget',
                type: 'ms.vss-dashboards-web.widget',
                targets: ['ms.vss-dashboards-web.widget-catalog'],
            },
            {
                id: 'settings-page',
                type: 'ms.vss-web.hub',
                targets: ['ms.vss-web.project-admin-hub-group'],
            },
        ],
        locales: ['cs', 'de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'pl', 'pt-BR', 'ru', 'tr', 'zh-Hans', 'zh-Hant'],
        localeCount: 14,
    },
    {
        id: 'p5-multi-level-query',
        publisher: 'cool-tools',
        displayName: 'cool·tools Multi-Level Query',
        marketplaceSlug: 'cool-tools.p5-multi-level-query',
        contributions: [
            {
                id: 'settings-page',
                type: 'ms.vss-web.hub',
                targets: ['ms.vss-web.project-admin-hub-group'],
            },
            {
                id: 'hub',
                type: 'ms.vss-web.hub',
                targets: ['ms.vss-work-web.work-hub-group'],
            },
            {
                id: 'query-results-export',
                type: 'ms.vss-web.action',
                targets: ['ms.vss-work-web.work-item-query-results-toolbar-menu'],
            },
            {
                id: 'export-dialog',
                type: 'ms.vss-web.external-content',
                targets: [],
            },
            {
                id: 'widget',
                type: 'ms.vss-dashboards-web.widget',
                targets: ['ms.vss-dashboards-web.widget-catalog'],
            },
        ],
        locales: ['cs', 'de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'pl', 'pt-BR', 'ru', 'tr', 'zh-Hans', 'zh-Hant'],
        localeCount: 14,
    },
];
